module.exports = __webpack_public_path__ + "img/10o9.facd5c4c.png";